import api from './interceptor';

const BASE_URL_V1 = 'api/v1/accounts';
const BASE_URL_V2 = 'api/v2/accounts';

export default {
  // API Version 1
  getAccount: accountId => api.get(`${BASE_URL_V1}/${accountId}`),
  getAccounts: params => api.get(`${BASE_URL_V1}`, { params }),
  getAccountsForDashboard: params => api.get(`${BASE_URL_V2}/dashboard`, { params }),
  deleteAccount: accountId => api.delete(`${BASE_URL_V1}/${accountId}`),
  activateAccount: accountId => api.put(`${BASE_URL_V1}/${accountId}/clinic`), // Don't know why we use here `/clinic`, but it's not a mistake.
  deactivateAccount: accountId => api.put(`${BASE_URL_V1}/${accountId}/deactivate`),
  unlockLogin: accountId => api.put(`${BASE_URL_V1}/${accountId}/unlock-login`),
  changeUserNotification: (accountId, params) => api.put(`${BASE_URL_V1}/${accountId}/notification-type`, params),
  addAccount: params => api.post(`${BASE_URL_V1}`, params),
  updateAvatar: (accountId, params) => api.patch(`${BASE_URL_V1}/${accountId}/avatar`, params),
  getDegrees: params => api.get(`${BASE_URL_V1}/degrees`, { params }),
  updateAccount: (accountId, params) => api.put(`${BASE_URL_V1}/${accountId}`, params),
  getSpecialities: params => api.get(`${BASE_URL_V1}/specialities`, { params }),
  getMedicalRecords: (accountId, params = {}) => api.get(`${BASE_URL_V1}/${accountId}/medical-records`, { params }),
  deleteMedicalRecord: (accountId, recordId) => api.delete(`${BASE_URL_V1}/${accountId}/medical-records/${recordId}`),
  uploadMedicalReport: (accountId, toUploadFile, onUploadProgress) => api({
    method: 'POST',
    url: `${BASE_URL_V1}/${accountId}/medical-records`,
    data: toUploadFile,
    onUploadProgress,
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  getMonitoringPatients: params => api.get(`${BASE_URL_V1}/rpm-patients`, { params }),
  verifyRpm: (patientId, params) => api.put(`${BASE_URL_V1}/rpm-patients/setVerified/${patientId}`, params),
  resendVerificationEmail: (patientId) => api.get(`${BASE_URL_V1}/${patientId}/resend-wellcome-email`),

  // API Version 2
  checkExistUsername: username => api.get(`${BASE_URL_V2}/exist/${username}`),
  getRadiologyViewURL: patientId => api.get(`${BASE_URL_V2}/${patientId}/radiology/view`),
  getRadiologyUploadURL: patientId => api.get(`${BASE_URL_V2}/${patientId}/radiology/upload`),
  forceAccountLogout: accountId => api.post(`${BASE_URL_V2}/${accountId}/logout`),
  checkEligibility: params => api.get(`${BASE_URL_V2}/check`, { params }),
  submitEmail: params => api.post(`${BASE_URL_V2}/submit-email`, params),
  getDischargeSummary: ({ clinicId, patientId = '', params }) => api.get(`${BASE_URL_V2}/${clinicId}/discharge-summary/${patientId}`, { params }),
  sendFileToPatient: ({ dischargeSummaryId, appointmentId }) => api.post(`${BASE_URL_V2}/discharge-summary/${dischargeSummaryId}/${appointmentId}/send`),
  uploadDischargeSummary: ({ clinicId, patientId = '', appointmentId = '', summary }) => api({
    method: 'POST',
    url: `${BASE_URL_V2}/${clinicId}/discharge-summary/${patientId ? `${patientId}/` : ''}${appointmentId}`,
    headers: { 'Content-Type': 'multipart/form-data' },
    data: summary,
  }),
  deleteDischargeSummary: (dischargeSummaryId) => api.delete(`${BASE_URL_V2}/discharge-summary/${dischargeSummaryId}`),
  searchReports: filtersObject => api({
    method: 'POST',
    url: `${BASE_URL_V2}/reports`,
    data: filtersObject,
    responseType: 'arraybuffer',
  }),
  uploadInsuranceFile: ({ id, side, formData }) => api({
    method: 'PATCH',
    url: `${BASE_URL_V2}/${id}/insurance-photo/${side}`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  createDependent: params => api.post(`${BASE_URL_V2}/dependents`, params),
  getDependents: params => api.get(`${BASE_URL_V2}/dependents`, { params }),
  deactivateDependent: (dependentId, params) => api.patch(`${BASE_URL_V2}/dependents/${dependentId}`, { active: false, ...params }),
  activateDependent: (dependentId, params) => api.patch(`${BASE_URL_V2}/dependents/${dependentId}`, { active: true, ...params }),
  updateDependent: (dependentId, params) => api.patch(`${BASE_URL_V2}/dependents/${dependentId}`, params),
};
